import React from "react";
import { Alert, Col, Row } from "reactstrap";
import { Link } from "react-router-dom";

const ResetPasswordSuccess = () => {
  return (
    <div className={"my-5"}>
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <Alert>
            <h3>Félicitation !</h3>
            <div className={"fw-bold"}>
              Votre mot de passe a été réinitialisé avec succès.
            </div>
          </Alert>
        </Col>
      </Row>
      <Row className={"my-4"}>
        <Col lg={6} xs={12} className={"mx-auto"}>
          <Row className={"d-flex justify-content-md-end"}>
            <Col lg={4} xs={12} className={""}>
              <Link to={"/auth/login"} className={"btn btn-primary w-100"}>
                Je me connecter
              </Link>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ResetPasswordSuccess;
